import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './index.css'
import axios from 'axios'
import { Navbar } from '../../../Components'
import { ClassOptions, ADMIN_API, TestTypes, USER_API } from '../../../functions'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import { useRef } from 'react';
import lottie from 'lottie-web';

const TestComponent = () => {
  const navigate = useNavigate();
  const optionsClass = ClassOptions();
  const [ifHidden, setIfHidden] = useState(false);
  const testTypes = TestTypes();
  const [ifScheduling, setIfScheduling] = useState(false);
  const [testInfo, setTestInfo] = useState({
    TestName: '',
    TestNumber: '',
    TestClass: '',
    TestDuration: '',
    TestDate: '',
    TestType: '',
    TestDelay: '',
    showAnalysis: false,
  });
  useEffect(() => {
    checkUser();
    setIfLoading(false);
  }, [])
  const [ifLoading, setIfLoading] = useState(true);
  const ref = useRef(null);


  const checkUser = async () => {
    const user = Cookies.get('user');
    if (user) {
      try {
        let res = await axios.get(`${USER_API}/getData/${user}`);
        if (res.status === 200) {
          if (!res.data.ifAdmin) {
            navigate('/login');
          }
        }
        else {
          Cookies.remove('user');
          navigate('/login');
        }
      }
      catch (err) {
        navigate('/login');
      }
    }
    else {
      navigate('/login');
    }
  }



  const PostToAPI = async () => {
    try {
      const formData = new FormData();
      formData.append("TestInfo", JSON.stringify(TestInfo));
      formData.append("QuestionSet", JSON.stringify({}));
      formData.append(`QuestionImg`, null);

      let res = await axios.post(`${ADMIN_API}/setTest`,
        formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      );
      // const res = await axios.post(`${ADMIN_API}/setTest`, {
      //   TestInfo: TestInfo
      // });
      if (res.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Test Created Successfully',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          navigate('/Admin/AllTests')
        })
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    }
    catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      })
    }

  }

  let TestInfo = testInfo;
  const handleCreateAndGetTest = () => {
    TestInfo = testInfo;
    let TestNameUnique = `${testInfo.TestClass}_${testInfo.TestName}`;
    if (!ifScheduling) {
      setTestInfo({ ...testInfo, TestDate: "", TestNumber: TestNameUnique });
      TestInfo = { ...testInfo, TestDate: "", TestNumber: TestNameUnique };
    }
    else {
      setTestInfo({ ...testInfo, TestNumber: TestNameUnique });
      TestInfo = { ...testInfo, TestNumber: TestNameUnique };
    }
    PostToAPI(TestInfo);
  }

  const Loader = () => {
    useEffect(() => {
      const Animator = lottie.loadAnimation({
        container: ref.current,
        animationData: require('../../../Components/Animations/LoadingBarsRotation.json'),
        renderer: 'svg',
        loop: true,
        autoplay: true,

      });
      return () => Animator.destroy();
    }, [])
    return (
      <div className='flex flex-col justify-center items-center h-screen'>
        <div className='text-2xl font-extrabold m-3'>
          Loading Test
        </div>
        <div className='w-1/2' ref={ref} ></div>
      </div>
    )
  }


  return (
    <>
      {ifLoading ? (
        <Loader />
      ) :
        (
          <div>
            <div className="space-y-12">
              <div className="sm:col-span-3">
                <label htmlFor="class" className="block text-sm font-medium leading-6 text-gray-900">
                  Test Title
                </label >
                <div className="mt-2">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder='E.g JEE MAINS MOCK TEST - 1'
                    value={testInfo.TestName}
                    onChange={(e) => {
                      setTestInfo({ ...testInfo, TestName: e.target.value });
                    }}
                    disabled={ifHidden}
                    className={`${ifHidden ? `disabled` : ``} block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
                  >
                  </input>
                </div>
              </div >

              <div className="sm:col-span-3">
                <label htmlFor="class" className="block text-sm font-medium leading-6 text-gray-900">
                  Test Class
                </label>
                <div className="mt-2">
                  <select
                    id="Testclass"
                    name="class"
                    value={testInfo.TestClass}
                    onChange={(e) => {
                      setTestInfo({ ...testInfo, TestClass: e.target.value });
                    }}
                    disabled={ifHidden}
                    className={`${ifHidden ? `disabled` : ``} block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
                  >
                    {optionsClass.map((option) => (
                      <option
                        key={option.id}
                      >
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="sm:col-span-3">
                <label htmlFor="class" className="block text-sm font-medium leading-6 text-gray-900">
                  Test Duration (in minutes)
                </label>
                <div className="mt-2">
                  <input
                    type="number"
                    id="duration"
                    name="duration"
                    placeholder='E.g 120'
                    value={testInfo.TestDuration}
                    onChange={(e) => {
                      setTestInfo({ ...testInfo, TestDuration: e.target.value });
                    }}
                    disabled={ifHidden}
                    className={` block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
                  >
                  </input>
                </div>

                <div className="sm:col-span-3 mt-10">
                  <label htmlFor="Type" className="block text-sm font-medium leading-6 text-gray-900">
                    Test Type
                  </label>
                  <div className="mt-2">
                    <select
                      id="TestType"
                      name="Type"
                      value={testInfo.TestType}
                      onChange={(e) => {
                        console.log(e.target.value)
                        setTestInfo({ ...testInfo, TestType: e.target.value });
                        console.log(testInfo);
                      }}
                      disabled={ifHidden}
                      className={`${ifHidden ? `disabled` : ``} block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
                    >
                      {testTypes.map((option) => (
                        <option
                          key={option.id}
                        >
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  {TestInfo.TestType === testTypes[1].name ? (
                    <div className="flex flex-col">
                      <label htmlFor="TestResultDate" className="block m-2 text-sm font-medium leading-6 text-gray-900">
                        Test Result Date
                      </label>
                      <input
                        type="datetime-local"
                        name="TestResultDate"
                        id="TestResultDate"
                        autoComplete="TestResultDate"
                        value={testInfo.TestDelay}
                        disabled={ifHidden}
                        onChange={(e) => {
                          e.preventDefault();
                          console.log(e.target.value)
                          setTestInfo({ ...testInfo, TestDelay: e.target.value });
                          console.log(testInfo);
                        }}
                        className="block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                      />
                    </div>
                  ) :
                    ("")
                  }
                </div>

              </div>

              <div className='flex align-middle'>
                <input
                  type="checkbox"
                  id="showAnalysis"
                  name="showAnalysis"
                  checked={testInfo.showAnalysis}
                  onChange={(e) => {
                    setTestInfo({ ...testInfo, showAnalysis: e.target.checked });
                  }}
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <label htmlFor="showAnalysis" className="ml-2 block text-sm font-medium text-gray-900">
                  Allow student to view test analysis after submission
                </label>
              </div>
              {
                ifScheduling && (
                  <div>
                    <div className="flex flex-col">
                      <label htmlFor="TestDate" className="block m-2 text-sm font-medium leading-6 text-gray-900">
                        Test Upload Date
                      </label>
                      <input
                        type="datetime-local"
                        name="TestDate"
                        id="TestDate"
                        autoComplete="TestDate"
                        value={testInfo.TestDate}
                        disabled={ifHidden}
                        onChange={(e) => {
                          e.preventDefault();
                          setTestInfo({ ...testInfo, TestDate: e.target.value });
                        }}
                        className="block p-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                      />
                    </div>

                  </div>
                )
              }
              {
                (ifScheduling) ? (
                  <div className=''>
                    <button
                      type="button"
                      onClick={() => {
                        setIfScheduling(false);
                      }
                      }

                      className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                      Unschedule test upload
                    </button>
                  </div>
                ) : (
                  <div className=''>
                    <button
                      type="button"
                      onClick={() => {
                        setIfScheduling(true);
                      }
                      }
                      className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600"
                    >
                      Schedule test upload
                    </button>
                  </div>
                )
              }
              <button onClick={(e) => {
                e.preventDefault();
                // console.log(testInfo)
                handleCreateAndGetTest();
              }} className="bg-indigo-600 text-white rounded-md m-3 px-3 py-2 text-sm font-semibold shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Create Test
              </button>
            </div >
          </div >
        )
      }
    </>
  )
}

const AddTest = () => {
  return (
    <div>
      <Navbar />
      <div className='p-5'>
        <TestComponent />
      </div>
    </div>
  )
}

export default AddTest
